// extracted by mini-css-extract-plugin
export var aircallIframe = "_mg-3";
export var fabContainer = "_mg-5";
export var fabRinging = "_mg-6";
export var loadingOverlay = "_mg-4";
export var pulse = "_mg-7";
export var widgetContent = "_mg-2";
export var widgetPanel = "_mg-0";
export var widgetPanelExpanded = "_mg-1";